
import React, { useCallback, useEffect, useState } from 'react'
import Auxiliary from '../../hoc/Auxiliary'
import ApiService from "../../services/ApiService"
import { useDispatch, useSelector } from 'react-redux'
import AlertService from '../../services/AlertService'
import { addSpinner, removeSpinner } from '../../store/actions/spinner'
import { v4 as uuidv4 } from 'uuid'
import Section_1 from '../sections/Section_1'
import Section_2 from '../sections/Section_2'
import Section_3 from '../sections/Section_3'
import Section_4 from '../sections/Section_4'
import Section_5 from '../sections/Section_5'
import Section_6 from '../sections/Section_6'
import SkeletonComponent from '../../components/Skeleton/SkeletonComponent'
import Skeleton_Section_4 from '../skeletonsSections/Skeleton_Section_4'
import Skeleton_Section_3 from '../skeletonsSections/Skeleton_Section_3'
import { YMaps, Map, Placemark } from "react-yandex-maps";

export default function Contact() {

  const dispatch = useDispatch();
  const { language } = useSelector(state => state.language);
  const { spinners } = useSelector(state => state.spinners);
  const [pageContent, setPageContent] = useState([]);

  const mapData = {
    center: [40.183574, 44.629344],
    zoom: 13,
  };

  const coordinates = [
    [40.183574, 44.629344],
  ];


  useEffect(() => {
    if (language) {
      getPageContentByName();
    }
    return () => {
      setPageContent([]);
    }
  }, [language])

  const getPageContentByName = () => {
    let spinnerId = uuidv4();
    setSpinner(spinnerId);
    ApiService.getPageContentByName("contact").then(response => {
      if (response && response.data) {
        setPageContent(response.data);
      }
      extractSpinner(spinnerId);
    }).catch(error => getFail(error, spinnerId))
  }

  const setSpinner = useCallback(spinner => {
    dispatch(addSpinner(spinner));
  }, []);

  const extractSpinner = useCallback(spinner => {
    setTimeout(() => {
      dispatch(removeSpinner(spinner));
    }, 500);
  }, []);

  const getFail = (error, spinnerId) => {
    error && AlertService.alert("error", error);
    spinnerId && extractSpinner(spinnerId);
  }

  if (spinners && spinners.length) {
    return <section className='section'>
      <Skeleton_Section_3 />
    </section>
  }

  return (
    <Auxiliary>
      {
        pageContent && pageContent.length ?
          pageContent.map((pageContentItem, index) => {
            return (() => {
              switch (pageContentItem.sectionType) {
                case 1:
                  if (pageContentItem.pageContents && pageContentItem.pageContents.length) {
                    let currentPageContent = pageContentItem.pageContents[0];
                    return <Section_1 key={index} currentPageContent={currentPageContent} />
                  }
                case 2:
                  if (pageContentItem.pageContents && pageContentItem.pageContents.length) {
                    let currentPageContent = pageContentItem.pageContents[0];
                    return <Section_2 key={index} currentPageContent={currentPageContent} />
                  }
                case 3:
                  if (pageContentItem.pageContents && pageContentItem.pageContents.length) {
                    const pageContents = pageContentItem.pageContents;
                    const pairedItems = [];
                    for (let i = 0; i < pageContents.length; i += 2) {
                      const pair = [pageContents[i], pageContents[i + 1]];
                      pairedItems.push(pair);
                    }
                    return <Section_3 key={index} pageContentItem={pageContentItem} pairedItems={pairedItems} sectionClassName="pb-0"/>
                  }
                //
                case 4:
                  if (pageContentItem.pageContents && pageContentItem.pageContents.length) {
                    return <Section_4 key={index} pageContentItem={pageContentItem} />
                  }
                case 5:
                  if (pageContentItem.pageContents && pageContentItem.pageContents.length) {
                    let currentPageContent = pageContentItem.pageContents[0];
                    return <Section_5 key={index} currentPageContent={currentPageContent} />
                  }
                case 6:
                  if (pageContentItem.pageContents && pageContentItem.pageContents.length) {
                    let currentPageContent = pageContentItem.pageContents[0];
                    return <Section_6 key={index} currentPageContent={currentPageContent} sectionClassName="pt-4" />
                  }
                //
                default:
                  break;
              }
            })()
          })
          : null
      }
      <div className='map footer p-0 overflow-hidden mt-0 shadow'>
        <YMaps query={{lang:"en_US"}} >
          <Map defaultState={mapData} width="80" height="400px" language="en_US">
            {coordinates.map((coordinate, index) =>
              <Placemark
                key={index}
                geometry={coordinate}
              />
            )}
          </Map>
        </YMaps>
      </div>

    </Auxiliary>
  )
}